import React from 'react'
import '../Sidebar/Sidebar.css';
function SidebarItem(props) {
    const active = props.active ? 'active' : ''
  return (
    <div className='sidebar__item'>
        <div className={`sidebar__item-inner ${active}`}>
            <i className={props.icon}></i>
            <span>
                {props.title}
            </span>
        </div>
    </div>
  )
}

export default SidebarItem